export default __webpack_public_path__ + "static/media/milwaukee-bucks.d89236eb.jpeg";